import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
import BlogPage from "./pages/BlogPage";
import UserPage from "./pages/UserPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import ProductsPage from "./pages/ProductsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import GameQuestionsPage from "./pages/GameQuestionsPage";
import GameUsersPage from "./pages/UsersPage";
import GameUserCardPage from "./pages/GameUserCardPage";
import GameQuestionCreatePage from "./pages/GameQuestionCreatePage";
import GameResultsPage from "./pages/GameResultsPage";
import GameCodesPage from "./pages/GameCodesPage";
import CustomLeaguesPage from "./pages/CustomLeaguesPage";
import DashboardPage from "./pages/DashboardPage";
import ScoreablesPage from "./pages/ScoreablesPage";
import ScoreablesDashboardPage from "./pages/ScoreablesDashboardPage";
import PacksDashboardPage from "./pages/PacksDashboardPage";
import PackPage from "./pages/PackPage";
import UsersPage from "./pages/UsersPage";
import UserPacksPage from "./pages/UserPacksPage";
import UserCardsPage from "./pages/UserCardsPage";
import StagesPage from "./pages/StagesPage";
import DivisionsPage from "./pages/DivisionsPage";
import UserLineupsPage from "./pages/UserLineupsPage";
import UserFootballLineupPage from "./pages/UserFootballLineupPage";
import MarketplaceDashboardPage from "./pages/MarketplaceDashboardPage";
import MarketplacePacksPage from "./pages/MarketplacePacksPage";
import MarketplacePackPage from "./pages/MarketplacePackPage";
import CoinTransactionsPage from "./pages/CoinTransactionsPage";
import ProfilePage from "./pages/ProfilePage";
import AppSettingsPage from "./pages/AppSettingsPage";
import LobbyPage from "./pages/LobbyPage";
import FixturesListPage from "./pages/FixturesListPage";
import FixturesBasicFeedsPage from "./pages/FixturesBasicFeedsPage";
import UserMarketplaceCardsPage from "./pages/UserMarketplaceCardsPage";
import CardPage from "./pages/CardPage";
import PrizeDrawsPage from "./pages/PrizeDrawsPage";
import PrizeDrawEntriesPage from "./pages/PrizeDrawEntriesPage";
import TicketTransactionsPage from "./pages/TicketTransactionsPage";
import StoreItemsPage from "./pages/StoreItemsPage";
import ProfileEditPage from "./pages/ProfileEditPage";
import ClubChallengesPage from "./pages/challenge/ClubChallengesPage";
import ChallengePage from "./pages/challenge/ChallengePage";
import CoinTransactionPage from "./pages/CoinTransactionPage";
import StageLeaderboardPage from "./pages/StageLeaderboardPage";
import MinigamesContestsPage from "./pages/MinigamesContestsPage";
import MinigamesContestEditPage from "./pages/MinigamesContestEditPage";
import CodesListPage from "./pages/CodesListPage";
import RedeemCodesPage from "./pages/RedeemCodesPage";
import MegaspinsPage from "./pages/MegaspinsPage";
import UserRewardsPage from "./pages/UserRewardsPage";
import StagesPeriodsPage from "./pages/StagesPeriodsPage";
import GameProvidersPage from "./pages/GameProvidersPage";
import AdminInboxMessagesPage from "./pages/AdminInboxMessagesPage";
import AdminInboxMessagePage from "./pages/AdminInboxMessagePage";
import VersusPage from "./pages/VersusPage";
import VersusPlaygroundPage from "./pages/VersusPlaygroundPage";
import VersusSeasonsPage from "./pages/VersusSeasonsPage";
import PrizeDrawAddPage from "./pages/PrizeDrawAddPage";
import WinnerListTable from "./pages/PrizeDrawWinnerList";
import VersusGameDetailsPage from "./pages/VersusGameDetailsPage";
import AddLobbyPage from "./pages/AddLobbyPage";
import FixtureFeedsPage from "./pages/FixtureFeedsPage";
import GameProviderEditPage from "./pages/GameProviderEditPage";
import AdminsPage from "./pages/AdminsPage";
import PromotionsPage from "./pages/PromotionsPage";
import PromotionPage from "./pages/PromotionPage";
import UserLevelsPage from "./pages/UserLevelsPage";
import UserLevelsEditPage from "./pages/UserLevelsEditPage";
import HomePage from "./pages/HomePage";
import CoinsDashboardPage from "./pages/CoinsDashboardPage";
import PacksNewDashboardPage from "./pages/PacksNewDashboardPage";
import PlayersPage from "./pages/PlayersPage";
import PlayerDetailPage from "./pages/PlayerDetailPage";
import TeamsPageAssets from "./pages/TeamsPageAssets";
import TeamsPageDetail from "./pages/TeamsPageDetail";
import ProfilePageNew from "./pages/ProfilePage";
import LineupsPage from "./pages/LineupsPage";
import AddLineupPage from "./pages/AddLineupPage";
import LevelUnlocksPage from "./pages/LevelUnlocksPage";
import PromotionRewardsPage from "./pages/PromotionRewardsPage";
import HammerSmashListPage from "./pages/HammerSmashListPage";
import HammerSmashPage from "./pages/HammerSmashPage";
import HammerSmashParticipantsPage from "./pages/HammerSmashParticipantsPage";
import DivisionsSettingsPage from "./pages/DivisionsSettingsPage";
import ChallengeSetupsPage from "./pages/challenge/ChallengeSetupsPage";
import CreateClubPage from "./pages/CreateClubPage";
import ChallengeSetupPage from "./pages/challenge/ChallengeSetupPage";
import MatchLiveScoringPage from "./pages/MatchLiveScoringPage";
import AddMatchPage from "./pages/AddMatchPage";
import XpAchievmentsPage from "./pages/XpAchievmentsPage";
import SeasonsPage from "./pages/SeasonsPage";
import SoundsPageAssets from "./pages/SoundsPageAssets";
import LeaderboardPage from "./pages/LeaderboardPage";
import CompetitionsPage from "./pages/CompetitionsPage";
import PackSettingsPage from "./pages/PackSettingsPage";
import StoreItemPage from "./pages/StoreItemPage";
import TenantsPage from "./pages/TenantsPage";
import AppComponentsPage from "./pages/AppComponentsPage";
import TenantOnboardingPage from "./pages/TenantOnboardingPage";
import ScoringPage from "./pages/ScoringPage";
import HomeComponentsPage from "./pages/homeComponents/HomeComponentsPage";
import HomeComponentEditPage from "./pages/homeComponents/HomeComponentEditPage";
import PackAssetsPage from "./pages/PackAssetsPage";
import PackAssetPage from "./pages/PackAssetPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/scoreables" />, index: true },
        { path: "home", element: <HomePage /> },
        { path: "admins", element: <AdminsPage /> },
        { path: "promotions", element: <PromotionsPage /> },
        { path: "promotions/promotion", element: <PromotionPage /> },
        {
          path: "promotions/:promotionId/rewards",
          element: <PromotionRewardsPage />,
        },
        { path: "hammer-smash", element: <HammerSmashListPage /> },
        { path: "hammer-smash/campaign", element: <HammerSmashPage /> },
        {
          path: "hammer-smash/:campaignId/participants",
          element: <HammerSmashParticipantsPage />,
        },
        { path: "user-levels", element: <UserLevelsPage /> },
        { path: "user-levels/edit", element: <UserLevelsEditPage /> },
        { path: "coins-spins-pass", element: <CoinsDashboardPage /> },
        { path: "scoreables", element: <ScoreablesDashboardPage /> },
        { path: "scoreables/competition-scoreables", element: <ScoreablesPage /> },
        { path: "competitions", element: <CompetitionsPage /> },
        { path: "tenants", element: <TenantsPage /> },
        { path: "packs", element: <PacksDashboardPage /> },
        { path: "packs-dashboard", element: <PacksNewDashboardPage /> },
        { path: "codes", element: <CodesListPage /> },
        { path: "redeem-codes", element: <RedeemCodesPage /> },
        { path: "game-providers", element: <GameProvidersPage /> },
        { path: "game-providers/:id", element: <GameProviderEditPage /> },
        { path: "pack-details", element: <PackPage /> },
        { path: "fixtures", element: <FixturesListPage /> },
        { path: "fixture/feeds", element: <FixtureFeedsPage /> },
        { path: "basic-feeds", element: <FixturesBasicFeedsPage /> },
        { path: "prize-draws", element: <PrizeDrawsPage /> },
        { path: "prize-draws/add", element: <PrizeDrawAddPage /> },
        {
          path: "prize-draws/:prizeDrawId/winner-list",
          element: <WinnerListTable />,
        },
        { path: "app-components", element: <AppComponentsPage /> },
        { path: "challenges", element: <ClubChallengesPage /> },
        { path: "challenges/:challengeId", element: <ChallengePage /> },
        { path: "challenge-setups", element: <ChallengeSetupsPage /> },
        { path: "create-club", element: <CreateClubPage /> },
        { path: "club/:clubId", element: <ChallengeSetupPage /> },
        { path: "challenge-setup/:setupId", element: <ChallengeSetupPage /> },
        { path: "prize-draws-entries", element: <PrizeDrawEntriesPage /> },
        { path: "users", element: <UsersPage /> },
        { path: "app-settings", element: <AppSettingsPage /> },
        { path: "profile", element: <ProfilePage /> },
        { path: "profile-new", element: <ProfilePageNew /> },
        { path: "profile-edit", element: <ProfileEditPage /> },
        { path: "lobby", element: <LobbyPage /> },
        { path: "lobby/add", element: <AddLobbyPage /> },
        { path: "home-components", element: <HomeComponentsPage /> },
        {
          path: "home-components/:homeComponentId",
          element: <HomeComponentEditPage />,
        },
        { path: "minigames/contests", element: <MinigamesContestsPage /> },
        {
          path: "minigames/contest/edit",
          element: <MinigamesContestEditPage />,
        },
        { path: "stages", element: <StagesPage /> },
        { path: "stages-periods", element: <StagesPeriodsPage /> },
        { path: "divisions", element: <DivisionsPage /> },
        { path: "divisions/settings", element: <DivisionsSettingsPage /> },
        { path: "stage/leaderboard", element: <StageLeaderboardPage /> },
        { path: "card-details", element: <CardPage /> },
        {
          path: "marketplace",
          element: <MarketplaceDashboardPage />,
          children: [
            { path: "store-items", element: <StoreItemsPage /> },
            { path: "megaspins", element: <MegaspinsPage /> },
          ]
        },
        {
          path: "marketplace-packs",
          element: <MarketplacePacksPage />,
        },
        {
          path: "marketplace-packs/pack",
          element: <MarketplacePackPage />,
        },
        { path: "coin-transactions", element: <CoinTransactionsPage /> },
        { path: "user-rewards", element: <UserRewardsPage /> },
        { path: "coin-transaction", element: <CoinTransactionPage /> },
        { path: "ticket-transactions", element: <TicketTransactionsPage /> },
        { path: "user-packs", element: <UserPacksPage /> },
        { path: "user-cards", element: <UserCardsPage /> },
        { path: "megaspins", element: <MegaspinsPage /> },
        { path: "versus", element: <VersusPage /> },
        { path: "versus/playground", element: <VersusPlaygroundPage /> },
        { path: "versus/seasons", element: <VersusSeasonsPage /> },
        {
          path: "versus-game-details/:gameId",
          element: <VersusGameDetailsPage />,
        },
        {
          path: "user-marketplace-cards",
          element: <UserMarketplaceCardsPage />,
        },
        { path: "user-lineups", element: <UserLineupsPage /> },
        { path: "inbox", element: <AdminInboxMessagesPage /> },
        { path: "inbox/message", element: <AdminInboxMessagePage /> },
        { path: "user-football-lineup", element: <UserFootballLineupPage /> },
        { path: "game/dashboard", element: <DashboardPage /> },
        { path: "game/questions", element: <GameQuestionsPage /> },
        { path: "game/questions/create", element: <GameQuestionCreatePage /> },
        { path: "game/users", element: <GameUsersPage /> },
        { path: "game/results", element: <GameResultsPage /> },
        { path: "game/user-card", element: <GameUserCardPage /> },
        { path: "game/codes", element: <GameCodesPage /> },
        { path: "leagues", element: <CustomLeaguesPage /> },
        { path: "app", element: <DashboardAppPage /> },
        { path: "user", element: <UserPage /> },
        { path: "products", element: <ProductsPage /> },
        { path: "blog", element: <BlogPage /> },
        { path: "players", element: <PlayersPage /> },
        { path: "players/:playerId", element: <PlayerDetailPage /> },
        { path: "players/new", element: <PlayerDetailPage /> },
        { path: "assets/teams", element: <TeamsPageAssets /> },
        { path: "assets/teams/:teamsId", element: <TeamsPageDetail /> },
        { path: "lineups", element: <LineupsPage /> },
        { path: "lineups/new", element: <AddLineupPage /> },
        { path: "lineups/edit/:lineupId", element: <AddLineupPage /> },
        { path: "levels/settings", element: <LevelUnlocksPage /> },
        { path: "fixtures/match-live-scoring", element: <MatchLiveScoringPage /> },
        { path: "fixtures/add-match", element: <AddMatchPage /> },
        { path: "xp-achievments", element: <XpAchievmentsPage /> },
        { path: "seasons", element: <SeasonsPage /> },
        { path: "sound", element: <SoundsPageAssets /> },
        { path: "leaderboard", element: <LeaderboardPage /> },
        { path: "packs/:type", element: <PackSettingsPage /> },
        { path: "tenant-onboarding", element: <TenantOnboardingPage /> },
        { path: "scoring", element: <ScoringPage /> },
        {
          path: "store-item/:id",
          element: <StoreItemPage />,
        },
        { path: "pack-assets", element: <PackAssetsPage /> },
        { path: "pack-assets/:id", element: <PackAssetPage /> },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
